"use strict";

var _defineProperty = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");
var _slicedToArray = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");
var _toConsumableArray = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = AgendaTableauCell;
var _react = _interopRequireWildcard(require("react"));
var _agenda2Themes = require("./agenda2Themes");
function _interopRequireWildcard(e, t) {
  if ("function" == typeof WeakMap) var r = new WeakMap(),
    n = new WeakMap();
  return (_interopRequireWildcard = function _interopRequireWildcard(e, t) {
    if (!t && e && e.__esModule) return e;
    var o,
      i,
      f = {
        __proto__: null,
        default: e
      };
    if (null === e || "object" != typeof e && "function" != typeof e) return f;
    if (o = t ? n : r) {
      if (o.has(e)) return o.get(e);
      o.set(e, f);
    }
    for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]);
    return f;
  })(e, t);
}
// Agenda Tableau: day tabs (same pill-bar look/behavior as Agenda2Cell) above or below a table whose
// column count (2-5) and column titles are configurable in the editor. Rows belong to a day, like
// Agenda 2.0's events, but live in their own tables (agenda_tableau_days / agenda_tableau_rows).

var pad = function pad(n) {
  return n.toString().padStart(2, '0');
};
var formatDateDots = function formatDateDots(date) {
  return pad(date.getUTCDate()) + '.' + pad(date.getUTCMonth() + 1) + '.' + date.getUTCFullYear();
};

// Comparable number for the calendar day of a Date read in UTC (YYYYMMDD).
var dayNumber = function dayNumber(date) {
  return date.getUTCFullYear() * 10000 + (date.getUTCMonth() + 1) * 100 + date.getUTCDate();
};
var nowAsWallClock = function nowAsWallClock() {
  var n = new Date();
  return new Date(Date.UTC(n.getFullYear(), n.getMonth(), n.getDate()));
};
var byDate = function byDate(field) {
  return function (a, b) {
    return new Date(a[field]) - new Date(b[field]);
  };
};
var COLUMN_KEYS = ['column_1', 'column_2', 'column_3', 'column_4', 'column_5'];
var DEFAULT_FONT = "OpenSans-Regular, 'Open Sans', sans-serif";
function AgendaTableauCell(_ref) {
  var cell = _ref.cell,
    intl = _ref.intl,
    _ref$uriTransformer = _ref.uriTransformer,
    uriTransformer = _ref$uriTransformer === void 0 ? function (u) {
      return u;
    } : _ref$uriTransformer;
  var days = (0, _react.useMemo)(function () {
    return _toConsumableArray(cell.days || []).sort(byDate('date'));
  }, [cell.days]);
  var rows = (0, _react.useMemo)(function () {
    return cell.rows || [];
  }, [cell.rows]);
  var columnsCount = Math.min(Math.max(cell.columns_count || 2, 2), 5);
  var columnKeys = COLUMN_KEYS.slice(0, columnsCount);
  var columnTitles = columnKeys.map(function (_key, i) {
    return cell["column_".concat(i + 1, "_title")] || "Colonne ".concat(i + 1);
  });
  var defaultDayId = (0, _react.useMemo)(function () {
    if (days.length === 0) return null;
    var today = dayNumber(nowAsWallClock());
    var current = days.find(function (day) {
      return dayNumber(new Date(day.date)) === today;
    });
    if (current) return current.id;
    var upcoming = days.find(function (day) {
      return dayNumber(new Date(day.date)) > today;
    });
    return (upcoming || days[0]).id;
  }, [days]);
  var _ref2 = (0, _react.useState)(null),
    _ref3 = _slicedToArray(_ref2, 2),
    pickedDay = _ref3[0],
    setPickedDay = _ref3[1];
  var selectedDay = days.some(function (d) {
    return d.id === pickedDay;
  }) ? pickedDay : defaultDayId;
  var locale = intl ? intl.locale : 'en';

  // The background image chosen in the editor wins; without one, the Euroseeds theme brings its own.
  var customBackground = cell.background_image_uri ? uriTransformer(cell.background_image_uri) : null;
  var backgroundImageUri = customBackground || (cell.color_theme === 'euroseeds' ? _agenda2Themes.EUROSEEDS_BACKGROUND : null);
  var backgroundSize = customBackground ? {
    contain: 'contain',
    stretch: '100% 100%'
  }[cell.background_fit] || 'cover' : 'cover';
  var backgroundImageStyle = backgroundImageUri ? {
    backgroundImage: 'url("' + backgroundImageUri + '")',
    backgroundSize: backgroundSize,
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat'
  } : {};
  var shownRows = rows.filter(function (row) {
    return row.agenda_tableau_day_id === selectedDay;
  }).sort(function (a, b) {
    return (a.sort_order || 0) - (b.sort_order || 0);
  });
  var radius = function radius(enabled, size) {
    return enabled ? size / 2 + 0.5 + 'em' : '0em';
  };
  var pill = function pill(selected, size, rounded) {
    return {
      flex: '1 0 auto',
      cursor: 'pointer',
      padding: '0.4em 0.9em',
      fontSize: size + 'em',
      fontWeight: 'bold',
      textAlign: 'center',
      transitionDuration: '200ms',
      background: selected ? cell.background_color_filter_day_checked : 'rgba(0,0,0,0)',
      color: selected ? cell.text_color_day_filter_selected : cell.text_color_day_filter,
      border: 'solid 0.1em ' + (selected ? cell.border_color_selected_day : 'rgba(0,0,0,0)'),
      borderRadius: radius(rounded, size)
    };
  };
  var dayBar = days.length > 0 && /*#__PURE__*/_react.default.createElement("div", {
    style: {
      display: 'flex',
      overflowX: 'auto',
      boxSizing: 'border-box',
      gap: '0.3em',
      padding: '0.35em',
      borderRadius: '999px',
      border: 'solid 1px ' + cell.border_color_selected_day,
      backgroundColor: cell.background_color_filter_day
    }
  }, days.map(function (day) {
    var date = new Date(day.date);
    var selected = selectedDay === day.id;
    return /*#__PURE__*/_react.default.createElement("div", {
      key: day.id,
      onClick: function onClick() {
        return setPickedDay(day.id);
      },
      style: pill(selected, cell.font_size_filter_day, cell.bolder_radius_filter_day)
    }, /*#__PURE__*/_react.default.createElement("div", null, date.toLocaleDateString(locale, {
      weekday: 'long',
      timeZone: 'UTC'
    })), /*#__PURE__*/_react.default.createElement("div", null, formatDateDots(date)));
  }));
  var table = /*#__PURE__*/_react.default.createElement("div", {
    style: {
      marginTop: '0.8em',
      overflowX: 'auto'
    }
  }, /*#__PURE__*/_react.default.createElement("div", {
    style: {
      borderRadius: '0.6em',
      overflow: 'hidden',
      border: 'solid 1px ' + cell.border_color_table
    }
  }, /*#__PURE__*/_react.default.createElement("table", {
    style: {
      width: '100%',
      borderCollapse: 'collapse'
    }
  }, /*#__PURE__*/_react.default.createElement("thead", null, /*#__PURE__*/_react.default.createElement("tr", {
    style: {
      backgroundColor: cell.background_color_header
    }
  }, columnTitles.map(function (title, i) {
    return /*#__PURE__*/_react.default.createElement("th", {
      key: i,
      style: {
        textAlign: 'left',
        padding: '0.6em 0.8em',
        color: cell.text_color_header,
        fontSize: cell.font_size_header + 'em',
        borderBottom: 'solid 1px ' + cell.border_color_table,
        borderRight: i < columnsCount - 1 ? 'solid 1px ' + cell.border_color_table : 'none'
      }
    }, title);
  }))), /*#__PURE__*/_react.default.createElement("tbody", null, shownRows.length === 0 && /*#__PURE__*/_react.default.createElement("tr", null, /*#__PURE__*/_react.default.createElement("td", {
    colSpan: columnsCount,
    style: {
      padding: '0.8em',
      textAlign: 'center',
      opacity: 0.6
    }
  }, "Aucune ligne")), shownRows.map(function (row) {
    return /*#__PURE__*/_react.default.createElement("tr", {
      key: row.id,
      style: {
        backgroundColor: cell.background_color_row
      }
    }, columnKeys.map(function (key, i) {
      return /*#__PURE__*/_react.default.createElement("td", {
        key: key,
        style: {
          padding: '0.6em 0.8em',
          borderBottom: 'solid 1px ' + cell.border_color_table,
          borderRight: i < columnsCount - 1 ? 'solid 1px ' + cell.border_color_table : 'none',
          fontSize: cell.font_size_cell + 'em',
          color: i === 0 ? cell.text_color_first_column : cell.text_color_row,
          fontWeight: i === 0 ? 'bold' : 'normal',
          whiteSpace: 'pre-line'
        }
      }, row[key]);
    }));
  })))));
  return /*#__PURE__*/_react.default.createElement("div", {
    style: _objectSpread(_objectSpread({
      padding: '4%',
      boxSizing: 'border-box',
      width: '100%',
      minHeight: '100%',
      backgroundColor: cell.background_color
    }, backgroundImageStyle), {}, {
      color: cell.text_color,
      fontFamily: cell.font_family || DEFAULT_FONT
    })
  }, cell.days_position !== 'below' && dayBar, table, cell.days_position === 'below' && dayBar);
}